import React from 'react';

import {Helmet, useParams} from 'views/module';

import JobList from 'views/scenes/career/job_scenes/JobView';

const JobListPage = () => {
  const params = useParams();
  const jobRn = params.jobRn;

  return (
    <>
      <Helmet>
        <title>Quilt: Job Details</title>
      </Helmet>
      <JobList
        jobRn={jobRn}
      />
    </>
  );
};

export default JobListPage;
